export const environment = {
    production: true,
    FRAPPE_API_URL: 'https://vendor.potentglobalsolutions.in'
};
